/*
 * Copyright (c) Nexign, JSC, 2020-2023.
 */
/**
 * Saga to check userTypeid for Guard
 *
 * @author Anton Panasenko
 * @author Evgeniy Naumov
 * @version 1.23.0
 * @since 1.4.0
 */

import get from 'lodash/get';
import { select } from 'redux-saga/effects';

import { EUserType } from '../../../pages/PageAuth/constants/authConstants';
import { makeSelectUserTypeId } from '../../../pages/PageAuth/selectors/authSelectors';
import { Access } from '../constants/guard/accessGuardConstants';
import { AccessComponentKeyEnum } from '../constants/guard/guardConstants';
import { IAccessItemAllowedParam } from '../types/guardTypes';

export function* checkGuardUserTypeIdSaga(componentKey: AccessComponentKeyEnum) {
    const userTypeId: number = yield select(makeSelectUserTypeId());
    const guardUserTypeId: IAccessItemAllowedParam<EUserType> | undefined = get(Access[componentKey], 'userTypeId');
    if (guardUserTypeId) {
        return guardUserTypeId.id.includes(userTypeId) === guardUserTypeId.isAllowed;
    }
    return true;
}
